const AUTH_STORAGE_KEY = 'portal:authState';

interface AuthUpdate {
  isAuthenticated: boolean;
  timestamp: number;
  source: string;
}

export const authStorage = {
  // Update auth state and notify other tabs
  updateAuthState: (isAuthenticated: boolean) => {
    const update: AuthUpdate = {
      isAuthenticated,
      timestamp: Date.now(),
      source: crypto.randomUUID() // Unique ID for this tab
    };
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(update));
  },

  // Get current auth state from storage
  getCurrentAuthState: (): AuthUpdate | null => {
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!stored) return null;
    
    try {
      return JSON.parse(stored) as AuthUpdate;
    } catch {
      return null;
    }
  },

  // Listen for auth state changes
  onAuthStateChange: (callback: (update: AuthUpdate) => void) => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key !== AUTH_STORAGE_KEY || !event.newValue) return;
      
      try {
        const update = JSON.parse(event.newValue) as AuthUpdate;
        callback(update);
      } catch (_error) {
        console.error('Failed to parse auth state update:', _error);
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }
};
